import styled from 'styled-components';
import DownloadSvg from '../../assets/mytrips/download.svg';

const DownloadIcon = styled(DownloadSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default DownloadIcon;
